import React, { useRef, useState, useEffect } from 'react';
import { Tooltip } from 'antd';
export const OverflowShowTooltips = props => {
    const { style, value, children, childText } = props;
    const [show, setShow] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        if (ref != null && ref.current != null && ref.current.scrollWidth > ref.current.offsetWidth) {
            setShow(true);
        }
    }, [ref, value]);
    const node = childText ? (React.createElement("div", Object.assign({ ref: ref }, props, { dangerouslySetInnerHTML: {
            __html: childText,
        } }))) : (React.createElement("div", Object.assign({ ref: ref }, props), value));
    if (show) {
        return (React.createElement(Tooltip, { autoAdjustOverflow: true, getPopupContainer: node => document.documentElement, title: value }, node));
    }
    return React.createElement(React.Fragment, null, node);
};
